import React from "react"
import { MainCP } from "../../../Components/confianza-empresa-cep/confianza-empresa-cep-v2/MainCP"

const ViewConfianzaCep: React.FC = () => <MainCP/>

export default ViewConfianzaCep